<script setup>
import { computed } from 'vue';
import Icon from 'next/icon/Icon.vue';

const { fileType } = defineProps({
  fileType: {
    type: String,
    required: true,
  },
});

const fileTypeIcon = computed(() => {
  const fileIconMap = {
    '7z': 'i-wasel-file-zip',
    csv: 'i-wasel-file-csv',
    doc: 'i-wasel-file-doc',
    docx: 'i-wasel-file-doc',
    json: 'i-wasel-file-txt',
    odt: 'i-wasel-file-doc',
    pdf: 'i-wasel-file-pdf',
    pfx: 'i-wasel-file-pfx',
    ppt: 'i-wasel-file-ppt',
    pptx: 'i-wasel-file-ppt',
    rar: 'i-wasel-file-zip',
    rtf: 'i-wasel-file-doc',
    tar: 'i-wasel-file-zip',
    txt: 'i-wasel-file-txt',
    xls: 'i-wasel-file-xls',
    xlsx: 'i-wasel-file-xls',
    xml: 'i-wasel-file-txt',
    zip: 'i-wasel-file-zip',
  };

  return fileIconMap[fileType] || 'i-teenyicons-text-document-solid';
});
</script>

<template>
  <Icon :icon="fileTypeIcon" />
</template>
